import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { Device } from 'DeviceUtils';

let baseStyles = {
    container: {
        height: '100%',
        backgroundColor: Theme.primaryBackgroundColor
    },
    scrollViewContainer: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    innerContainer: {
        flex: 1,
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'center',
        marginHorizontal: Theme.primaryMargin
    },
    containerItem: {
        margin: Theme.BU / 2
    },
    titleContainer: {
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'center'
    },
    title: {
        fontFamily: Theme.regularFont,
        fontSize: 25,
        marginHorizontal: 18,
        marginBottom: 10,
        color: Theme.primaryTextColor,
        textAlign: 'center'
    },
    question: {
        fontFamily: Theme.regularFont,
        color: Theme.primaryTextColor,
        fontSize: 23,
        textAlign: 'center',
        marginVertical: 20
    },
    buttonsContainer: {
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
    }
};

if (Device.isTabletOrWeb) {
    baseStyles = {
        ...baseStyles,
        innerContainer: {
            ...baseStyles.innerContainer,
            marginHorizontal: '25%'
        },
        buttonsContainer: {
            ...baseStyles.buttonsContainer,
            flexDirection: 'row-reverse'
        }
    };
}

export default StyleSheet.create(baseStyles);
